const isEmpty = (value) =>
  value === null || value === undefined || value === '';

export default isEmpty;
